import { createAsyncThunk, createSlice, createAction } from "@reduxjs/toolkit";
import axios from "axios";
// import baseUrl from "../../../utils/url";
const baseUrl = process.env.REACT_APP_BASEURL;
//register action
export const registerUserAction = createAsyncThunk(
  "user/register",
  async (user, { rejectWithValue, getState, dispatch }) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    //http call
    try {
      const { data } = await axios.post(
        `${baseUrl}/api/reseller/create`,
        user,
        config
      );
        //save user into local storage
        localStorage.setItem("sellerregisterInfo", JSON.stringify(data));
      return data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const registerecomSellerAction = createAsyncThunk(
  "user/customregister",
  async (user, { rejectWithValue, getState, dispatch }) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    //http call
    try {
      const { data } = await axios.post(
        `${baseUrl}/api/reselleraction/customregister`,
        user,
        config
      );
      return data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);
//Login
export const loginUserAction = createAsyncThunk(
  "user/login",
  async (userData, { rejectWithValue, getState, dispatch }) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      //make http call
      const { data } = await axios.post(
        `${baseUrl}/api/reseller/login`,
        userData,
        config
      );
      //save user into local storage
      localStorage.setItem("sellerregisterInfo", JSON.stringify(data));
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);
// export const loginUserAction = createAsyncThunk(
//   "user/login",
//   async (userData, { rejectWithValue, getState, dispatch }) => {
//     const config = {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     };
//     try {
//       //make http call
//       const { data } = await axios.post(
//         `${baseUrl}/api/reselleraction/login`,
//         userData,
//         config
//       );
//       //save user into local storage
//       localStorage.setItem("sellerInfo", JSON.stringify(data));
//       return data;
//     } catch (error) {
//       if (!error?.response) {
//         throw error;
//       }
//       return rejectWithValue(error?.response?.data);
//     }
//   }
// );
export const logincustomsellerAction = createAsyncThunk(
  "user/customlogin",
  async (userData, { rejectWithValue, getState, dispatch }) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      //make http call
      const { data } = await axios.post(
        `${baseUrl}/api/reselleraction/customlogin`,
        userData,
        config
      );
      //save user into local storage
      localStorage.setItem("customsellerInfo", JSON.stringify(data));
      return data;
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);
//Logout action
export const logoutAction = createAsyncThunk(
  "users/logout",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      localStorage.removeItem("sellerInfo");
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const customlogoutAction = createAsyncThunk(
  "users/customlogout",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      localStorage.removeItem("customsellerInfo");
    } catch (error) {
      if (!error?.response) {
        throw error;
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);
//fetch User details
export const fetchUserDetailsAction = createAsyncThunk(
    "user/detail",
    async (id, { rejectWithValue, getState, dispatch }) => {
      try {
        const { data } = await axios.get(`${baseUrl}/api/reselleraction/${id}`);
        return data;
      } catch (error) {
        if (!error?.response) throw error;
        return rejectWithValue(error?.response?.data);
      }
    }
  );
  
//get user from local storage and place into store
const sellerLoginFromStorage = localStorage.getItem("sellerInfo")
  ? JSON.parse(localStorage.getItem("sellerInfo"))
  : null;
  // const sellerregisterFromStorage = localStorage.getItem("sellerregisterInfo")
  // ? JSON.parse(localStorage.getItem("sellerregisterInfo"))
  // : null;
  const customsellerLoginFromStorage = localStorage.getItem("customsellerInfo")
  ? JSON.parse(localStorage.getItem("customsellerInfo"))
  : null;
//slices
const usersSlices = createSlice({
  name: "sellers",
  initialState: {
    sellerAuth: sellerLoginFromStorage,
    customsellerAuth:customsellerLoginFromStorage,
    // sellerregisterAuth:sellerregisterFromStorage
  },
  extraReducers: (builder) => {
    //--------------------------------register------------------------------------//

    builder.addCase(registerUserAction.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(registerUserAction.fulfilled, (state, action) => {
      state.loading = false;
      state.registered = action?.payload;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(registerUserAction.rejected, (state, action) => {
      console.log(action.payload);
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.serverErr = action?.error?.message;
    });
    
    //-------------------------------------signup-------------------------------------//


    builder.addCase(registerecomSellerAction.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(registerecomSellerAction.fulfilled, (state, action) => {
      state.loading = false;
      state.registered = action?.payload;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(registerecomSellerAction.rejected, (state, action) => {
      console.log(action.payload);
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.serverErr = action?.error?.message;
    });

    //-------------------------------------login-------------------------------------//

    builder.addCase(loginUserAction.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(loginUserAction.fulfilled, (state, action) => {
      state.sellerAuth = action?.payload;
      state.loading = false;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(loginUserAction.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.serverErr = action?.error?.message;
      state.loading = false;
    });


    
    builder.addCase(logincustomsellerAction.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(logincustomsellerAction.fulfilled, (state, action) => {
      state.customsellerAuth = action?.payload;
      state.loading = false;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(logincustomsellerAction.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.serverErr = action?.error?.message;
      state.loading = false;
    });
    //Logout
    builder.addCase(logoutAction.pending, (state, action) => {
      state.loading = true;
      // state.appErr=undefined
      // state.serverError=undefined
    });
    builder.addCase(logoutAction.fulfilled, (state, action) => {
      state.sellerAuth = undefined;
      state.loading = undefined;
      state.loading = false;
      state.appErr = undefined;
      state.serverError = undefined;
    });
    builder.addCase(logoutAction.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.serverError = action?.error?.message;
      state.loading = false;
    });
    builder.addCase(customlogoutAction.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(customlogoutAction.fulfilled, (state, action) => {
      state.customsellerAuth = undefined;
      state.loading = undefined;
      state.loading = false;
      state.appErr = undefined;
      state.serverError = undefined;
    });
    builder.addCase(customlogoutAction.rejected, (state, action) => {
      state.appErr = action?.payload?.message;
      state.serverError = action?.error?.message;
      state.loading = false;
    });
    //-------------------------------------------user details--------------------------------------//

    builder.addCase(fetchUserDetailsAction.pending, (state, action) => {
        state.loading = true;
        state.appErr = undefined;
        state.serverErr = undefined;
      });
      builder.addCase(fetchUserDetailsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = action?.payload;
        state.appErr = undefined;
        state.serverErr = undefined;
      });
      builder.addCase(fetchUserDetailsAction.rejected, (state, action) => {
        
        state.loading = false;
        state.appErr = action?.payload?.message;
        state.serverErr = action?.error?.message;
      });
  },
});

export default usersSlices.reducer;
